import React from 'react';
import { UserIcon, MailIcon, PhoneIcon, BriefcaseIcon, LinkedinIcon, BuildingIcon, MapPinIcon, DollarSignIcon, CpuIcon } from 'lucide-react';
export function DatabaseFields() {
  return <section className="py-24 bg-slate-50" data-id="element-3902">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3903">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3904">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-3905">
            Comprehensive{' '}
            <span className="text-blue-600" data-id="element-3906">local business listings</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-3907">
            Our local business database provides deep employee-level data, so
            you can reach the exact decision maker with verified business owner
            emails every time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3908">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3909">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3910">
              <UserIcon className="w-6 h-6" data-id="element-3911" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3912">
              Owner names
            </h3>
            <p className="text-slate-600" data-id="element-3913">
              First and last names of local business owners, founders, and
              managers.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3914">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3915">
              <MailIcon className="w-6 h-6" data-id="element-3916" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3917">
              Business owner emails
            </h3>
            <p className="text-slate-600" data-id="element-3918">
              Direct business owner emails and employee lists, verified in
              real-time.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3919">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3920">
              <BriefcaseIcon className="w-6 h-6" data-id="element-3921" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3922">
              Job titles
            </h3>
            <p className="text-slate-600" data-id="element-3923">
              Filter by Owner, Founder, GM, Marketing Director, etc.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3924">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3925">
              <PhoneIcon className="w-6 h-6" data-id="element-3926" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3927">
              Direct phones
            </h3>
            <p className="text-slate-600" data-id="element-3928">
              Mobile and direct dial numbers for key decision makers.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3929">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3930">
              <LinkedinIcon className="w-6 h-6" data-id="element-3931" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3932">
              Social profiles
            </h3>
            <p className="text-slate-600" data-id="element-3933">
              LinkedIn profiles for employees and the company.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3934">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3935">
              <BuildingIcon className="w-6 h-6" data-id="element-3936" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3937">
              Firmographics
            </h3>
            <p className="text-slate-600" data-id="element-3938">
              Company size, employee count, and founding year.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3939">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3940">
              <MapPinIcon className="w-6 h-6" data-id="element-3941" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3942">
              Location data
            </h3>
            <p className="text-slate-600" data-id="element-3943">
              Precise HQ addresses and multi-location branch data.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3944">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3945">
              <DollarSignIcon className="w-6 h-6" data-id="element-3946" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3947">
              Revenue estimates
            </h3>
            <p className="text-slate-600" data-id="element-3948">
              Estimated annual revenue to qualify your local business leads.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3949">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3950">
              <CpuIcon className="w-6 h-6" data-id="element-3951" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3952">
              Tech stack
            </h3>
            <p className="text-slate-600" data-id="element-3953">
              Technologies used by the business (Shopify, Toast, etc).
            </p>
          </div>
        </div>
      </div>
    </section>;
}